// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rHmN","toggleWrap":"styles_toggleWrap__1eXY6","content":"styles_content__3ha9a","selectAreaCode":"styles_selectAreaCode__3R4yl"};